import React from "react";
import { MaterialDesignIcons } from "../styled";

export const PlusMIcon: React.FC<{ fontSize?: string }> = ({ fontSize }) => {
  return <MaterialDesignIcons fontSize={fontSize}>add</MaterialDesignIcons>;
};
